const quotes = [
    {
        quote: "Until you value yourself, you will not value your time. Until you value your time, you will not do anything with it.", 
        author: "M. Scott Peck"
    },
    {
        quote: "I must govern the clock, not be governed by it.",
        author: "Golda Meir"
    },
    {
        quote: "Your greatest asset is your earning ability. Your greatest resource is your time.",
        author: "Brian Tracy"
    },
    {
        quote: "Give me six hours to chop down a tree and I will spend the first four sharpening the axe.",
        author: "Abraham Lincoln"
    },
    {
        quote: "You can only manage time if you track it right.",
        author: "Spica’s team"
    },
    {
        quote: "Concentrate all your thoughts upon the work in and. The sun’s rays do not burn until brought to a focus.",
        author: "Alexander Graham Bell"
    },
    {
        quote: "Don’t wait. The time will never be just right.",
        author: "Napoleon Hill"
    },
    {
        quote: "The secret of your future is hidden in your daily routine.",
        author: "Mike Murdock"
    },
    {
        quote: "It’s not the daily increase but daily decrease. Hack away at the unessential.",
        author: "Bruce Lee"
    },
    {
        quote: "You can have it all. Just not all at once.",
        author: "Oprah Winfrey"
    }
];

export const quoteToday = () => {
    const index = Math.floor(Math.random() * (quotes.length + 1));
    return quotes[index];
}